// eMAR and inpatient pharmacy (docs/plans/phase2-emar-inpatient-pharmacy.md §3.2).
import { queryOptions } from '@tanstack/react-query';
import {
  emarSettingsSchema,
  medicationChartSchema,
  wardOrdersSchema,
  type EmarSettings,
  type RecordAdministrationBody,
  type VerifyOrderBody,
} from '@wodi/shared';

import { api } from './client.ts';

/** The chart refreshes every minute, like the ward worklist, so due doses move on. */
export const CHART_REFRESH_MS = 60_000;

export const medicationChartQuery = (admissionId: string) =>
  queryOptions({
    queryKey: ['inpatient', 'medicines', admissionId],
    queryFn: () =>
      api('GET', `/admissions/${admissionId}/medication-chart`, { schema: medicationChartSchema }),
    refetchInterval: CHART_REFRESH_MS,
  });

export const recordAdministration = (admissionId: string, body: RecordAdministrationBody) =>
  api('POST', `/admissions/${admissionId}/administrations`, {
    body,
    schema: medicationChartSchema,
  });

export const administrationInError = (id: string, reason: string) =>
  api('POST', `/medication-administrations/${id}/entered-in-error`, {
    body: { reason },
    schema: medicationChartSchema,
  });

export const wardOrdersQuery = queryOptions({
  queryKey: ['pharmacy', 'ward-orders'],
  queryFn: () => api('GET', '/pharmacy/ward-orders', { schema: wardOrdersSchema }),
  refetchInterval: CHART_REFRESH_MS,
});

export const verifyOrder = (lineId: string, body: VerifyOrderBody) =>
  api('POST', `/pharmacy/ward-orders/${lineId}/verify`, { body, schema: wardOrdersSchema });

export const verificationInError = (id: string, reason: string) =>
  api('POST', `/medication-order-verifications/${id}/entered-in-error`, {
    body: { reason },
    schema: wardOrdersSchema,
  });

export const emarSettingsQuery = queryOptions({
  queryKey: ['settings', 'emar'],
  queryFn: () => api('GET', '/settings/emar', { schema: emarSettingsSchema }),
});

export const saveEmarSettings = (body: EmarSettings) =>
  api('PUT', '/settings/emar', { body, schema: emarSettingsSchema });
